module.exports = __webpack_public_path__ + "assets/img/Trade-Glass-Depot-Website-w720.d955fce0.jpg";